import { z } from "zod";

export const OnlinePOSProductConnectionSchema = z.object({
  onlinePOSProductId: z.nullable(z.number()),
  productId: z.string(),
});

export type OnlinePOSProductConnection = z.infer<
  typeof OnlinePOSProductConnectionSchema
>;
